import * as React from 'react';
import * as styles from './ImagePreview.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var ImagePreview = function ImagePreview(_ref) {
  var file = _ref.file;
  return /*#__PURE__*/_jsx("img", {
    src: file.objectUrl,
    alt: "",
    className: styles['image']
  });
};